import { z } from "zod";

import { storeLocationSchema } from "./location.schema";

/**
 * Lowercase, hyphenated slug. Uniqueness (case-insensitive, among
 * non-deleted stores) is enforced by the backend — see
 * docs/database-schema.md §5.1 partial unique index `uq_stores_slug_active`.
 */
export const storeSlugSchema = z
  .string()
  .trim()
  .toLowerCase()
  .min(3)
  .max(160)
  .regex(
    /^[a-z0-9]+(-[a-z0-9]+)*$/,
    "Slug must contain only lowercase letters, numbers, and hyphens.",
  );

/** docs/business-rules.md §11.4: hold duration must be 12, 24, or 48 hours. */
export const storeHoldDurationHoursSchema = z.union([z.literal(12), z.literal(24), z.literal(48)]);

export const createStoreSchema = z.object({
  name: z.string().trim().min(1).max(200),
  slug: storeSlugSchema,
  description: z.string().trim().max(5000).optional(),
  defaultHoldDurationHours: storeHoldDurationHoursSchema.optional(),
  location: storeLocationSchema,
});
export type CreateStoreInput = z.infer<typeof createStoreSchema>;

export const updateStoreSchema = z.object({
  name: z.string().trim().min(1).max(200).optional(),
  description: z.string().trim().max(5000).optional(),
  defaultHoldDurationHours: storeHoldDurationHoursSchema.optional(),
  timezone: z.string().trim().min(1).max(100).optional(),
  logoUrl: z.string().trim().url().optional(),
  coverImageUrl: z.string().trim().url().optional(),
  /** Bank account for receiving Order payments (ADR-0016 §5.1). */
  bankName: z.string().trim().min(1).max(200).optional(),
  bankAccountNumber: z.string().trim().min(1).max(50).optional(),
  bankAccountName: z.string().trim().min(1).max(200).optional(),
});
export type UpdateStoreInput = z.infer<typeof updateStoreSchema>;
